import React, { useMemo } from 'react';

import {
  Flex, GridItem, Text,
} from '@chakra-ui/react';
import {
  Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart,
} from 'recharts';

import colors from 'theme/colors';

const Label = ({
  width,
  x,
  y,
  value,
}) => (
  <Text
    alignSelf="center"
    variant="xSmallBold"
    as="text"
    dx={width + 5}
    x={x}
    y={y + 5}
    dy={10}
    fill="primary.default">
    {value}
  </Text>
);

export default function MaterialsPerRegionalCard({ data = [] }) {
  const max = useMemo(
    () => Math.max(...data.map(({ materials }) => materials)),
    [data],
  );
  return (
    <GridItem
      as={Flex}
      bg="white.default"
      color="gray.50"
      flexDir="column"
      borderRadius={8}
      colSpan={3}>
      <Flex
        p={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px">
        <Text
          variant="xSmallBold"
          color="gray.600">
          Materiais Coletados por Regional
        </Text>
      </Flex>
      <Flex
        width="100%"
        p={4}>
        <Flex
          width="100%"
          height="100%"
          maxHeight={200}
          overflowY="scroll"
          px={2}>
          <ResponsiveContainer
            height={180 + ((data.length || 5 - 5) * 40)}>
            <BarChart
              layout="vertical"
              data={data}>
              <CartesianGrid
                horizontal={false}
                strokeDasharray="3 3"
              />
              <XAxis
                type="number"
                tickCount={max > 10 ? 10 : max}
                domain={[0, max + (max * 0.15)]}
              />
              <YAxis
                width={100}
                type="category"
                dataKey="name"
              />
              <Tooltip />
              <Bar
                background={false}
                barSize={25}
                dataKey="materials"
                name="Número de materiais"
                fill={colors.primary.default}
                label={Label}
              />
            </BarChart>
          </ResponsiveContainer>
        </Flex>
      </Flex>
    </GridItem>
  );
}
